import { Injectable } from '@angular/core';
import { SETTINGS } from '../configs/common.settings';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  clientsChange = new BehaviorSubject(false);

  constructor(private http: HttpClient, private router: Router) {}

  createClient(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/client/create`, payload);
  }
  updateClient(payload: any): Observable<any> {
    return this.http.put(`${SETTINGS.BASE_API}/client/update`, payload);
  }

  getAllClients(payload: any): Observable<any> {
    return this.http.post(
      `${SETTINGS.BASE_API}/client/get-all/active`,
      payload
    );
  }

  getOneClientById(id: any): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/client/get/${id}`);
  }

  getPagedClients(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/client/get-paged`, payload);
  }

  getAttachmentsByClientId(id: any): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/client/get-attachment/${id}`);
  }
}
